import { useI18n } from "../../lib/i18n";

export const Marquee = () => {
  const { t } = useI18n();
  const items = [...t.marquee, ...t.marquee];
  return (
    <section className="relative overflow-hidden border-y border-ink/10 bg-pearl py-6 sm:py-7" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {items.map((m, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className={`px-6 font-display text-2xl font-extrabold uppercase tracking-tight sm:text-4xl ${i % 2 ? "text-outline" : "text-ink"}`}>{m}</span>
                <svg viewBox="0 0 24 24" className="h-5 w-5 text-champagne sm:h-6 sm:w-6" fill="currentColor" aria-hidden="true">
                  <path d="M12 0l2.2 9.8L24 12l-9.8 2.2L12 24l-2.2-9.8L0 12l9.8-2.2z" />
                </svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
